import { FC } from "react";

import WidgetContainer, { WidgetContainerProps } from "../WidgetContainer";

export type GoogleMapsWidgetErrorProps = WidgetContainerProps;

const GoogleMapsWidgetError: FC<GoogleMapsWidgetErrorProps> = ({ children, ...containerProps }) => {
  return (
    <WidgetContainer {...containerProps}>
      <div className="text-supportError">{children}</div>
    </WidgetContainer>
  );
};

export default GoogleMapsWidgetError;
